import Body from '../Body/Body';
import DashedLine from './DashedLine';
import InfoModule from './InfoModule';
import { Event } from '../../app/(main)/events/[slug]/page.val';
import { useVal } from '../../val/val.client';
import LinkBoxContainer from '../LinkBox/LinkBoxContainer';
import jobsPageVal from '../../app/(main)/jobb/page.val';

const FestComponent = ({
  location,
  introduction,
  main,
  program,
  signup,
  date,
  eventFull,
  typeformId,
}: Event) => {
  const page = useVal(jobsPageVal);
  const jobs = page['/jobb'];
  const availablePositions = jobs.availablePositions;

  return (
    <>
      <div className="flex flex-row px-[20px] laptop:px-[50px] desktop:px-[150px] justify-center">
        <div className="flex flex-row w-full max-w-[1260px]">
          <div className="flex flex-col w-full gap-8 ">
            <section className="flex flex-col gap-10 py-[30px] laptop:px-[30px] desktop:px-[30px]">
              <Body
                richText={introduction}
                size={'large'}
                className={
                  'font-[200] text-[24px] laptop:text-[24px] leading-[170%] laptop:leading-[175%] tracking-[0.03em] laptop:tracking-[0.05em]'
                }
              />
              <Body
                richText={main}
                className={
                  ' text-[18px] tablet:text-[22px] laptop:text-[22px] desktop:text-[22px]'
                }
              />
            </section>
            <section className="flex flex-col gap-10 py-[30px] laptop:px-[30px] desktop:px-[30px]">
              <div className="mb-[calc(-2.5rem+10px)] laptop:mb-0 desktop::mb-0 laptop:hidden">
                <DashedLine />
              </div>
              <div className="z-10 laptop:hidden desktop:hidden">
                <InfoModule
                  program={program}
                  date={new Date(date)}
                  location={location}
                  eventUrl={signup?.url ?? undefined}
                  signupOpen={!!signup?.opens}
                  signupOpens={
                    signup?.opens ? new Date(signup.opens) : undefined
                  }
                  eventFull={eventFull}
                  typeformId={typeformId ?? undefined}
                />
              </div>
            </section>
          </div>
          <div className="hidden laptop:block laptop:relative mt-[-100px] ml-[40px] right-0 z-10">
            <InfoModule
              program={program}
              date={new Date(date)}
              location={location}
              eventUrl={signup?.url ?? undefined}
              signupOpen={signup ? true : undefined}
              signupOpens={signup?.opens ? new Date(signup.opens) : undefined}
              eventFull={eventFull}
              typeformId={typeformId ?? undefined}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row  laptop:px-[50px] desktop:px-[150px] justify-center">
        <div className="flex flex-col max-w-[1260px] w-full gap-[130px] tablet:gap-[130px] laptop:gap-[160px] desktop:gap-[160px]">
          <div className="w-full flex flex-col gap-4 laptop:gap-[0px] desktop:gap-[0px]">
            <DashedLine className=" my-[5px]" />
          </div>
        </div>
      </div>
      <div className="flex flex-row px-[20px] laptop:px-[50px] desktop:px-[150px] justify-center">
        <LinkBoxContainer
          items={availablePositions
            .filter((pos) => pos.active)
            .map((pos) => ({
              title: pos.title,
              description: pos.description,
              url: pos.positionSlug,
            }))}
        />
      </div>
    </>
  );
};

export default FestComponent;
